import React, { HTMLProps, ReactNode } from "react";
import WarningOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import './FormErrorSection.scss';

// A plain string keeps the existing "just the section name" behavior (e.g. AddEditReferralsRequest).
// { section, message } additionally shows the specific validation message next to the section link.
export type FormErrorSectionItem = string | { section: string; message?: string };

type FormErrorSectionProps = HTMLProps<HTMLDivElement> & {
  sectionsWithErrors: FormErrorSectionItem[];
  onSectionClick: (section: string) => void;
};

const FormErrorSection: React.FC<FormErrorSectionProps> = ({
  sectionsWithErrors,
  onSectionClick
}) => {

  const scrollToSection = (section: string) => {
    onSectionClick?.(section);

    const id = section.replace(/\s+/g, "").toLowerCase();
    const element = document.getElementById(id);
    element?.scrollIntoView({
      behavior: "smooth"
    })
  }

  return (
    <div id='form-validation-banner' className="form-error-section">
      <WarningOutlinedIcon className="warning-icon"/>
      <div>
        <p className="title">One or more required fields are not complete.</p>
        <p>Click on the links below to respond to the missing fields. Then, try submitting again.</p>
        <ul>
          {sectionsWithErrors.map((i, index) => {
            const section = typeof i === 'string' ? i : i.section;
            const message = typeof i === 'string' ? undefined : i.message;
            // Multiple entries can share the same section (e.g. one per missing document type),
            // so the key can't be the section alone or React would collapse them into one.
            return (
              <li key={`${section}-${index}`}>
                <span className="section-link" onClick={() => scrollToSection(section)}>{section}</span>
                {message && <span className="section-message">: {message}</span>}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export default FormErrorSection;